<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col-6">
            <h2>Sesiones individuales</h2>
            <h5>Alumno: {{nombre}}</h5>
        </div>
        <div class="col-6">
            <button class="btn btn-color2" (click)="volverAExpediente()">Volver</button>
        </div>
    </div>
    <div>
        <table *ngIf="sesionesIndividuales.length" class="table table-bordered table-striped table-hover" datatable="ng" [dtOptions]="dtOptions">
            <thead>
            <tr style="background-color: #002061; color: #eee;">
                <th style="width:2%">NUMERO</th>
                <th style="width:10%">FECHA</th>
                <th style="width:10%">CREADO POR</th>
                <th style="width:10%">PROXIMA SESION</th>
                <th style="width:15%">DETALLES</th>
            </tr>
            </thead>
            <tbody>
                <tr *ngFor="let sesionIndividual of sesionesIndividuales">
                    <td>{{ sesionIndividual.clave }}</td>
                    <td>{{ sesionIndividual.fecha }}</td>
                    <td>{{ sesionIndividual.creador }}</td>
                    <td>{{ sesionIndividual.aplica == 'APLICA' ? sesionIndividual.proxima :
                        sesionIndividual.aplica == 'NO APLICA' ? sesionIndividual.aplica : 'NINGUNO' }}</td>
                    <td title="Ver detalles de la sesión"><button class="btn btn-color1" (click)="detallesSesionIndividual(sesionIndividual.id_sesion)">Ver detalles <fa-icon [icon]="icon1"></fa-icon></button></td>
                </tr>
            </tbody>
        </table>
        <div>
            <h5 *ngIf="!sesionesIndividuales.length" style="color: rgb(102, 4, 4);">*No hay ninguna sesión para mostrar</h5>
            <div class="text-center" *ngIf="registrar">
                <h6>Clic al botón para registrar una sesión individual a este alumno</h6>
                <button class="btn btn-outline-success" (click)="registroIndividual()">Registrar</button>
            </div>
        </div>
    </div>
</div>

